const PopUpIcon = () => {
  return (
      <svg
        width="73"
        height="73"
        viewBox="0 0 73 73"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="checked (1) 1" clipPath="url(#clip0_758_3858)">
          <g id="Group">
            <g id="Group_2">
              <path
                id="Vector"
                d="M36.5 0C16.3747 0 0 16.3747 0 36.5C0 56.6253 16.3747 73 36.5 73C56.6253 73 73 56.6253 73 36.5C73 16.3747 56.6253 0 36.5 0ZM56.8997 26.8947L33.5727 50.0388C32.2005 51.411 30.005 51.5025 28.5414 50.1303L16.1917 38.8784C14.7281 37.5063 14.6366 35.2193 15.9173 33.7556C17.2895 32.292 19.5764 32.2005 21.0401 33.5727L30.8283 42.5376L51.6855 21.6805C53.1491 20.2168 55.4361 20.2168 56.8997 21.6805C58.3634 23.1441 58.3634 25.4311 56.8997 26.8947Z"
                fill="#7BC875"
              />
            </g>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_758_3858">
            <rect width="73" height="73" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};
export default PopUpIcon;
